// extracted by mini-css-extract-plugin
export default {"button":"Button_button__1EObo","default":"Button_default__aqJNC","outline":"Button_outline__h0W25"};